/* eslint-disable camelcase */
import {
  DialogActions,
  TextField,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Switch,
  InputBase,
  Typography,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useEffect, useState, useMemo } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import format from 'date-fns/format'
import isAfter from 'date-fns/isAfter'
import startOfDay from 'date-fns/startOfDay'
import { useHistory } from 'react-router-dom'

import styles from '../../../resources/theme/users'
import SelectField from '../../components/SelectField'
import AsyncRequest from '../../components/AsyncRequest'
import NumberFormatCustom from '../../components/NumberFormat'
import NumberFormatCustomNoDecimals from '../../components/NumberFormatNoDecimals'
import colors from '../../../assets/colors'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { getLaundryBillingType } from '../BillingActions'

function BillingForm(props) {
  const { data, onClose, onSubmit, classes } = props
  const billingTypes = useSelector(state => state.billing.laundryBillingTypes)
  const paymentMethods = useSelector(state => state.billing.paymentMethods)
  const banks = useSelector(state => state.billing.banks)

  const styles = filterStylesComponents()

  const history = useHistory()

  const [form, updateForm] = useState({
    id: '',
    date: null,
    person: '',
    billing_type: '',
    description: '',
    value: '',
    payment_method: '',
    is_paid: false,
    replicate: 1,
    actual_payment_date: null,
  })

  const dispatch = useDispatch()

  const updateFields = React.useCallback(
    (name, value) => {
      updateForm({
        ...form,
        [name]: value,
      })
    },
    [form]
  )

  const handleClose = () => onClose && onClose()

  const onSubmitForm = e => {
    e.preventDefault()
    const data = {
      ...form,
      date: form.date ? format(new Date(form.date), 'yyyy-MM-dd') : '',
      actual_payment_date: form.actual_payment_date
        ? format(new Date(form.actual_payment_date), 'yyyy-MM-dd')
        : '',
    }
    onSubmit && onSubmit(data)
  }

  useEffect(() => {
    updateForm({ ...form, ...data })
  }, [data])

  const readOnly = useMemo(() => data?.service, [data])

  const noEdit = useMemo(() => [3, 4]?.includes(data?.billing_type?.id), [data])

  // Centro de custo: no cadastro/edição só faz sentido oferecer os ativos.
  // Exceção: se a conta editada já aponta para um centro deletado, mantém ele
  // na lista para não esvaziar o campo (o filtro continua usando a lista completa).
  const billingTypeOptions = useMemo(() => {
    const actives = (billingTypes || []).filter(type => !type.deleted_at)
    const selectedId = form.billing_type?.id

    if (selectedId && !actives.some(type => type.id === selectedId)) {
      const selected = (billingTypes || []).find(type => type.id === selectedId)
      if (selected) return [...actives, selected]
    }

    return actives
  }, [billingTypes, form.billing_type])

  const disableIsPaid = useMemo(() => {
    if (!form.actual_payment_date) return false

    return isAfter(
      startOfDay(new Date(form.actual_payment_date)),
      startOfDay(new Date())
    )
  }, [form.actual_payment_date])

  useEffect(() => {
    if (disableIsPaid && form.is_paid) {
      updateForm(prev => ({ ...prev, is_paid: false }))
    }
  }, [disableIsPaid])

  return (
    <ValidatorForm onSubmit={onSubmitForm}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography style={{ color: colors.textGray, marginTop: '12px' }}>
            Não achou um contato financeiro?{' '}
            <Typography
              target="_blank"
              component={Button}
              style={{
                color: colors.secondary,
                fontWeight: '700',
                padding: 0,
                margin: 0,
                backgroundColor: 'transparent',
                textTransform: 'capitalize',
              }}
              onClick={() => history.push('/supplier/new')}
            >
              Clique Aqui
            </Typography>{' '}
            para cadastrar!
          </Typography>
        </Grid>

        <Grid item sm={data ? 4 : 8} xs={12}>
          <AsyncRequest
            label="Contato"
            link="client-filter"
            setForm={updateFields}
            data={form.person}
            name="person"
            disabled={readOnly || noEdit}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <SelectField
            style={{ marginTop: '0px' }}
            options={billingTypeOptions}
            setForm={updateFields}
            data={form.billing_type || null}
            name="billing_type"
            label="Centro de Custo"
            disabled={noEdit}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <SelectField
            options={paymentMethods}
            setForm={updateFields}
            data={form.payment_method}
            name="payment_method"
            label="Método de pagamento"
            disabled={noEdit}
          />
        </Grid>

        <Grid item sm={4} xs={12} lg={4}>
          <SelectField
            style={{ marginTop: '0px' }}
            options={banks}
            setForm={updateFields}
            data={form.bank || null}
            disabled={noEdit}
            name="bank"
            label="Banco"
          />
        </Grid>

        {/* {data && (
          <Grid item xs={12} sm={4}>
            <TextField
              label="Data do cadastro"
              readOnly
              fullWidth
              type="date"
              value={form?.created_at}
            />
          </Grid>
        )} */}

        <Grid item sm={4} xs={12} lg={4}>
          <TextField
            className={classes.formControl}
            label="Valor"
            value={form.value}
            onChange={e => updateForm({ ...form, value: e.target.value })}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            disabled={noEdit}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KeyboardDatePicker
            clearable
            value={form.date}
            label="Data do vencimento"
            fullWidth
            clearLabel="Limpar"
            invalidDateMessage="Data inválida"
            autoOk
            onChange={date => updateForm({ ...form, date })}
            maxDate={new Date('2300-01-01')}
            format="dd/MM/yyyy"
            readOnly={noEdit}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KeyboardDatePicker
            clearable
            value={form?.actual_payment_date}
            label="Data do Pagamento"
            fullWidth
            clearLabel="Limpar"
            invalidDateMessage="Data inválida"
            autoOk
            onChange={date =>
              updateForm({ ...form, actual_payment_date: date })
            }
            maxDate={new Date('2300-01-01')}
            format="dd/MM/yyyy"
            readOnly={noEdit}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TextField
            type="text"
            pattern="[0-9]*"
            className={classes.formControl}
            label="Replicar por mês"
            value={form.replicate}
            onChange={e => updateForm({ ...form, replicate: e.target.value })}
            InputProps={{
              inputComponent: NumberFormatCustomNoDecimals,
            }}
            disabled={noEdit}
          />
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(form.is_paid)}
                    onChange={e =>
                      updateForm({ ...form, is_paid: e.target.checked })
                    }
                    value={form.is_paid}
                  />
                }
                label={
                  form.id
                    ? 'Baixar pagamento'
                    : 'Criar com o pagamento realizado.'
                }
                disabled={noEdit || disableIsPaid}
              />
            </Grid>

            {disableIsPaid && (
              <Grid item xs={12}>
                <Typography
                  style={{ fontSize: '12px', color: colors.graylight }}
                >
                  Você não pode dar baixa em um pagamento com data do pagamento
                  futura.
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <InputBase
            placeholder="Descrição"
            value={form.description}
            onChange={e => updateForm({ ...form, description: e.target.value })}
            variant="outlined"
            multiline
            fullWidth
            minRows={5}
            maxRows={10}
            inputProps={{
              style: {
                borderBottom: `2px solid ${colors.graylight}`,
              },
            }}
            disabled={noEdit}
          />
        </Grid>

        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Button className={styles.btnSalvar} type="submit" disabled={noEdit}>
            Salvar
          </Button>
        </Grid>
      </Grid>
    </ValidatorForm>
  )
}

export default withStyles(styles)(BillingForm)
